import { Crew } from '@src/main/modules/ibdp/domain/crew.interface';
import { IbdpRepository } from '@src/main/modules/ibdp/domain/ibdp.repository';

export const findCrew = async (repository: IbdpRepository, filter: string): Promise<Crew[]> =>
  await repository.findCrewSearch(filter);
